module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.isInformationModalVisible) ? _c('information') : _vm._e(), _vm._v(" "), (_vm.loading || _vm.initializingState) ? _c('spinner') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('dismissable-alert', {
    attrs: {
      "isShowing": _vm.isShowingReinvestmentNotice,
      "title": "Please take note!",
      "subtitle": "Transactions reinvested at the same rate/term on the same day will be reinvested together into one Note.",
      "notice": " Transactions that do not amount to $20 or greater when combined will be repaid to the default destination.",
      "alertType": "warning",
      "showIcon": true,
      "icon": "calendar-payment",
      "dismissible": false
    }
  }), _vm._v(" "), (_vm.isExtraReinvestmentsEnabled && _vm.scheduledAdditionalInvestments.length > 0) ? _c('div', {
    staticClass: "scheduled-investments-section"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "section-description"
  }, [_vm._v("\n              These additional deposits are scheduled to be combined with your reinvestments.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "scheduled-investments-list"
  }, _vm._l((_vm.scheduledAdditionalInvestments), function(investment) {
    return _c('div', {
      key: investment.id,
      staticClass: "scheduled-investment-item"
    }, [_c('div', {
      staticClass: "investment-info"
    }, [_c('span', {
      staticClass: "investment-notes"
    }, [_c('strong', [_vm._v(_vm._s(investment.noteId))])]), _vm._v(" "), _c('span', {
      staticClass: "investment-amount"
    }, [_vm._v("\n                    " + _vm._s(_vm.formatAmount(Number(investment.amount))) + "\n                  ")]), _vm._v(" "), _c('span', {
      staticClass: "investment-date"
    }, [_vm._v("\n                    Reinvests on " + _vm._s(_vm.formatDate(investment.reinvestDate)) + "\n                  ")]), _vm._v(" "), _c('span', {
      staticClass: "investment-status"
    }, [(investment.status === 'PENDING') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (investment.status === 'FUNDS_TRANSFERRED') ? _c('span', {
      staticClass: "label label-info"
    }, [_vm._v("Funds Transferred")]) : _vm._e(), _vm._v(" "), (investment.status === 'PROCESSED') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Processed")]) : _vm._e(), _vm._v(" "), (investment.status === 'CANCELLED') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (investment.status === 'FAILED') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e()])]), _vm._v(" "), (investment.status === 'FUNDS_TRANSFERRED') ? _c('div', {
      staticClass: "investment-actions"
    }, [_vm._m(2, true)]) : _vm._e(), _vm._v(" "), (investment.status === 'PENDING') ? _c('div', {
      staticClass: "investment-actions"
    }, [_c('button', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editAdditionalInvestment(investment)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Edit\n                  ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.confirmCancelAdditionalInvestment(investment)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-times"
    }), _vm._v(" Cancel\n                  ")])]) : _vm._e()])
  }))]) : _vm._e(), _vm._v(" "), (_vm.isExtraReinvestmentsEnabled && _vm.hasUpcomingTransactions) ? _c('div', {
    staticClass: "add-funds-section"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleAddFundsToReinvestments
    }
  }, [_vm._v("\n                  Add funds to my reinvestments\n                ")])])])]) : _vm._e(), _vm._v(" "), _c('upcoming-transactions', {
    attrs: {
      "notes-transactions": _vm.notesTransactionsWithNoAction,
      "allowed-actions": _vm.actionsAllowedForThisTransaction,
      "funding-sources": _vm.fundingSources,
      "submits-disabled": _vm.submitsDisabled,
      "year-rates": _vm.yearRates,
      "action-provided": false
    },
    on: {
      "actionChanged": _vm.actionChanged,
      "submit": _vm.submitUpcomingTransaction
    }
  }, [_c('em', {
    staticClass: "fa fa-exchange text-blue"
  }), _vm._v("Transactions you need to\n            provide direction on\n          ")]), _vm._v(" "), _c('upcoming-transactions', {
    attrs: {
      "notes-transactions": _vm.notesTransactionsWithAction,
      "allowed-actions": _vm.actionsAllowedForThisTransaction,
      "funding-sources": _vm.fundingSources,
      "submits-disabled": _vm.submitsDisabled,
      "year-rates": _vm.yearRates,
      "action-provided": ""
    },
    on: {
      "actionChanged": _vm.actionChanged,
      "submit": _vm.submitUpcomingTransaction
    }
  }, [_c('em', {
    staticClass: "fa fa-exchange text-gray"
  }), _vm._v("Transactions you've\n            provided direction on\n          ")])], 1)])]), _vm._v(" "), (_vm.showAddMoneyModal) ? _c('add-money-modal', {
    attrs: {
      "funding-sources": _vm.availableFundingSources,
      "available-notes": _vm.availableNotesForReinvestment,
      "loading": _vm.addMoneyLoading,
      "editing-investment": _vm.editingInvestment
    },
    on: {
      "close": _vm.closeAddMoneyModal,
      "submit": _vm.submitAddMoney
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCancelConfirmModal) ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-100px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("Cancel Additional Investment")]), _vm._v(" "), _c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("\n            Are you sure you want to cancel this additional investment of "), _c('strong', [_vm._v(_vm._s(_vm.cancellingInvestment ? _vm.formatAmount(Number(_vm.cancellingInvestment.amount)) : ''))]), _vm._v(" for note "), _c('strong', [_vm._v(_vm._s(_vm.cancellingInvestment ? _vm.cancellingInvestment.noteId : ''))]), _vm._v("?\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "modal-paragraph text-muted"
  }, [_vm._v("\n            This action cannot be undone.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg",
    attrs: {
      "type": "button",
      "disabled": _vm.cancellingLoading
    },
    on: {
      "click": _vm.closeCancelConfirmModal
    }
  }, [_vm._v("\n                  Keep Investment\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "type": "button",
      "disabled": _vm.cancellingLoading
    },
    on: {
      "click": _vm.cancelAdditionalInvestment
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.cancellingLoading ? 'Cancelling...' : 'Yes, Cancel It') + "\n                ")])])])])])])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Upcoming transactions\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "section-title"
  }, [_c('em', {
    staticClass: "fa fa-plus-circle text-success"
  }), _vm._v(" Scheduled Additional Investments\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "text-muted"
  }, [_c('em', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Transfer in progress")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "add-funds-explainer"
  }, [_c('p', {
    staticClass: "explainer-text"
  }, [_c('strong', [_vm._v("Add funds to your reinvestments:")]), _vm._v(" Maturing notes or interest payments that are scheduled to reinvest can receive additional funds to reinvest alongside them. This allows you to increase your investment amount when your existing notes mature or have interest transact. You can add funds between 45 and 3 days before the reinvestment date.\n                  ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4438b84","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UpcomingTransactionsForInvestor.vue
// module id = 2200
// module chunks = 1